export default "__VITE_ASSET__GVgJjSok__"